import ajax from "./ajax";

export function requestPlacements(query) {
  return ajax("/settings/placements", { query });
}

export function createCustomPlacement(data) {
  return ajax("/settings/placements", { method: "POST", data });
}

export function deleteCustomPlacement(id) {
  return ajax(`/settings/placements/${id}`, { method: "DELETE" });
}

export function requestTheme(query) {
  return ajax("/enterprises/theme", { query });
}

export function addTheme(data) {
  return ajax("/enterprises/theme", { method: "POST", data });
}

/** Square icon previews for the branding page; nothing is saved. */
export function previewEnterpriseIcon(data) {
  return ajax("/enterprises/branding/icon-preview", { method: "POST", data });
}

export function createEnterprise(data) {
  return ajax("/enterprises", { method: "POST", data });
}

export function editEnterprise(data) {
  return ajax("/enterprises", { method: "PUT", data });
}

export function getCurrencySettings() {
  return ajax("/settings/currency");
}

export function setCurrencySettings(data) {
  return ajax("/settings/currency", { method: "PUT", data });
}

export function requestTours(query) {
  return ajax("/settings/tours", { query });
}

export function updateTours(data) {
  return ajax("/settings/tours", { method: "PUT", data });
}

export function requestPrintModes(query) {
  return ajax("/printing/print_modes", { query });
}

export function requestMaxPrintSizes() {
  return ajax("/settings/maxPrintSizes");
}

export function getPricingTemplates() {
  return ajax("/settings/pricing-templates");
}

export function addPricingTemplates(data) {
  return ajax("/settings/pricing-templates", { method: "POST", data });
}

export function editPricingTemplates(id, data) {
  return ajax(`/settings/pricing-templates/${id}`, { method: "PUT", data });
}

export function deletePricingTemplates(id, { reassignTo } = {}) {
  return ajax(`/settings/pricing-templates/${id}`, {
    method: "DELETE",
    query: reassignTo ? { reassignTo } : undefined,
  });
}

export function getPricingTemplateConnections(id) {
  return ajax(`/settings/pricing-templates/${id}/connections`);
}

export function getOrderStatusColorTags() {
  return ajax("/settings/tags");
}

export function addOrderStatusColorTags(data) {
  return ajax("/settings/tags", { method: "POST", data });
}

export function getUserSettings(data) {
  return ajax("/settings/user-settings/manufacturingSettings");
}

export function saveUserSettings(data) {
  return ajax("/settings/user-settings/manufacturingSettings", {
    method: "POST",
    data,
  });
}

export function saveEnterpriseSetting(id, data) {
  return ajax(`/settings/enterprise-settings/${id}`, {
    method: "POST",
    data,
  });
}

export function getEnterpriseSetting(id) {
  return ajax(`/settings/enterprise-settings/${id}`);
}

export function calculateAutoOrderingDeliveryDays() {
  return ajax("/settings/auto-ordering/delivery-days");
}

export function syncOrderEmailTemplate(data) {
  return ajax("/settings/enterprise-settings/order-email-template/sync", {
    method: "POST",
    data,
  });
}

export function getOrderEmailTemplate() {
  return ajax("/settings/enterprise-settings/order-email-template");
}

export function resetOrderEmailTemplate() {
  return ajax("/settings/enterprise-settings/order-email-template", {
    method: "DELETE",
  });
}

export function updateOrderEmailNotificationEnabled(data) {
  return ajax("/settings/enterprise-settings/order-email-template/enabled", {
    method: "PUT",
    data,
  });
}

export function getQuoteEmailTemplates() {
  return ajax("/settings/enterprise-settings/quote-email-templates");
}

export function syncQuoteEmailTemplate(data) {
  return ajax("/settings/enterprise-settings/quote-email-templates/sync", {
    method: "POST",
    data,
  });
}

export function resetQuoteEmailTemplate(templateType) {
  return ajax(`/settings/enterprise-settings/quote-email-templates/${templateType}`, {
    method: "DELETE",
  });
}

export function updateQuoteEmailTemplateEnabled(templateType, data) {
  return ajax(`/settings/enterprise-settings/quote-email-templates/${templateType}/enabled`, {
    method: "PUT",
    data,
  });
}

export function getAdminNotificationRecipients() {
  return ajax("/settings/enterprise-settings/admin-notification-recipients");
}

export function updateAdminNotificationRecipients(data) {
  return ajax("/settings/enterprise-settings/admin-notification-recipients", {
    method: "PUT",
    data,
  });
}

export function getProductionUpdateNotifications() {
  return ajax("/settings/enterprise-settings/production-update-notifications");
}

export function previewPostmarkLifecycleEmail(data) {
  return ajax("/settings/enterprise-settings/postmark-lifecycle-preview", {
    method: "POST",
    data,
  });
}

export function syncProductionUpdateNotifications(data) {
  return ajax("/settings/enterprise-settings/production-update-notifications/sync", {
    method: "POST",
    data,
  });
}

export function updateProductionUpdateNotificationEnabled(stage, data) {
  return ajax(
    `/settings/enterprise-settings/production-update-notifications/${stage}/enabled`,
    {
      method: "PUT",
      data,
    }
  );
}

export function resetProductionUpdateNotifications() {
  return ajax("/settings/enterprise-settings/production-update-notifications", {
    method: "DELETE",
  });
}

export function getOrderMessageEmailSettings() {
  return ajax("/settings/enterprise-settings/order-message-email");
}

export function syncOrderMessageEmailSettings(data) {
  return ajax("/settings/enterprise-settings/order-message-email/sync", {
    method: "POST",
    data,
  });
}

export function resetOrderMessageEmailSettings() {
  return ajax("/settings/enterprise-settings/order-message-email", {
    method: "DELETE",
  });
}

export function getOutboundEmailOverview() {
  return ajax("/settings/outbound-email/overview");
}

export function getOutboundEmailAccounts() {
  return ajax("/settings/outbound-email/accounts");
}

export function createOutboundEmailDomain(data) {
  return ajax("/settings/outbound-email/domains", {
    method: "POST",
    data,
  });
}

export function refreshOutboundEmailDomain(domainId) {
  return ajax(`/settings/outbound-email/domains/${domainId}/refresh`, {
    method: "POST",
  });
}

export function createOutboundEmailDomainSenderIdentity(domainId, data) {
  return ajax(`/settings/outbound-email/domains/${domainId}/sender-identities`, {
    method: "POST",
    data,
  });
}

export function getGmailConnectUrl(data) {
  return ajax("/settings/outbound-email/accounts/gmail/connect-url", {
    method: "POST",
    data,
  });
}

export function getMicrosoftConnectUrl(data) {
  return ajax("/settings/outbound-email/accounts/microsoft/connect-url", {
    method: "POST",
    data,
  });
}

export function createOutboundEmailSmtpAccount(data) {
  return ajax("/settings/outbound-email/accounts/smtp", {
    method: "POST",
    data,
  });
}

export function updateOutboundEmailSmtpAccount(identityId, data) {
  return ajax(`/settings/outbound-email/accounts/${identityId}/smtp`, {
    method: "PUT",
    data,
  });
}

export function testOutboundEmailAccount(identityId, data) {
  return ajax(`/settings/outbound-email/accounts/${identityId}/test`, {
    method: "POST",
    data,
  });
}

export function updateOutboundEmailAccountReplyRouting(identityId, data) {
  return ajax(`/settings/outbound-email/accounts/${identityId}/reply-routing`, {
    method: "PUT",
    data,
  });
}

export function verifyOutboundEmailAccountReplyRouting(identityId) {
  return ajax(`/settings/outbound-email/accounts/${identityId}/reply-routing/verify`, {
    method: "POST",
  });
}

export function disconnectOutboundEmailAccount(identityId) {
  return ajax(`/settings/outbound-email/accounts/${identityId}`, {
    method: "DELETE",
  });
}

export function deleteOutboundEmailAccount(identityId) {
  return ajax(`/settings/outbound-email/accounts/${identityId}`, {
    method: "DELETE",
  });
}

export function deleteOutboundEmailDomain(domainId) {
  return ajax(`/settings/outbound-email/domains/${domainId}`, {
    method: "DELETE",
  });
}

export function getOutboundEmailStores() {
  return ajax("/settings/outbound-email/stores");
}

export function getOutboundEmailStoreAssignment(shopId) {
  return ajax(`/settings/outbound-email/stores/${shopId}/assignment`);
}

export function updateOutboundEmailStoreAssignment(shopId, data) {
  return ajax(`/settings/outbound-email/stores/${shopId}/assignment`, {
    method: "PUT",
    data,
  });
}

export function saveShippingPriceUpcharge(data) {
  return ajax("/enterprises/shipping", {
    method: "POST",
    data,
  });
}

export function getShippingPriceUpcharge() {
  return ajax(`/enterprises/shipping`);
}

export function getLocationStatus() {
  return ajax("/enterprises/location");
}

/** Network shop products + this location's opt outs / order. */
export function getLocationCatalog() {
  return ajax("/enterprises/location/catalog");
}

export function updateLocationStatus(data, locationId) {
  return ajax(`/enterprises/locations/${locationId}`, { method: "PUT", data });
}

/** Big Frog: provision franchise child + location + admin login credentials. */
export function createFranchiseLocation(data) {
  return ajax("/enterprises/locations", { method: "POST", data });
}

/** Big Frog HQ: look up a store's public address to pre-fill the create form. */
export function lookupFranchiseAddress(name) {
  return ajax(
    `/enterprises/franchise-address-lookup?name=${encodeURIComponent(name || "")}`,
  );
}

/** Big Frog HQ: franchise admins invited with each store, plus setup status. */
export function getFranchisees() {
  return ajax("/enterprises/franchisees");
}

/** Resend the set-password email for one franchise store. */
export function resendFranchiseeInvite(childEnterpriseId) {
  return ajax(`/enterprises/franchisees/${childEnterpriseId}/resend`, {
    method: "POST",
  });
}

/** Big Frog HQ: every franchise store's national store routing health.
 *  Cache busted so a reload always reflects the latest store setup. */
export function getFranchiseStoreHealth() {
  return ajax(`/enterprises/franchise-health?_t=${Date.now()}`);
}

/** Big Frog HQ: per location order health (late, in production, shipped,
 *  average time to ship, last order) for the Franchise network dashboard. */
export function getFranchiseNetworkMetrics(lateDays = 3) {
  return ajax(
    `/enterprises/franchise-network-metrics?lateDays=${encodeURIComponent(lateDays)}`,
  );
}

/** All Orders saved filter views, stored per user. */
export const ORDERS_SAVED_VIEWS_SETTINGS_ID = "ordersSavedViews";

export function getOrdersSavedViews() {
  return ajax(`/settings/user-settings/${ORDERS_SAVED_VIEWS_SETTINGS_ID}`);
}

export function saveOrdersSavedViews(views) {
  return ajax(`/settings/user-settings/${ORDERS_SAVED_VIEWS_SETTINGS_ID}`, {
    method: "POST",
    data: { settings: { views } },
  });
}

// Inventory admin alerts, on or off for the whole enterprise.
export function getInventoryEmailAlerts() {
  return ajax("/settings/enterprise-settings/inventory-email-alerts");
}

export function updateInventoryEmailAlerts(alerts) {
  return ajax("/settings/enterprise-settings/inventory-email-alerts", {
    method: "PUT",
    data: { alerts },
  });
}
